import React from 'react';
import { Control, useController, useWatch } from 'react-hook-form';
import { SplitShares } from 'types/splits.types';
import { formatValue } from 'app/components/Song/Splits/utils';
import { ListItem } from 'app/components/ChakraTableList';
import { InputField } from 'app/components/Core';
import { InputProps } from '@chakra-ui/react';

interface SplitTextFieldProps {
  control: Control<SplitShares>;
  index: number;
}

export const SplitTextField: React.FC<
  SplitTextFieldProps & Partial<InputProps>
> = ({ sx, control, index, ...rest }) => {
  const name = `members.${index}.share` as const;
  const { fieldState, field } = useController({ name, control });

  // have to use watched value instead of field.value, otherwise UI is not updated in memoized List
  const watch = useWatch({ name, control });

  return (
    <ListItem
      sx={{
        '> div': {
          h: 'unset',
        },
      }}
    >
      <InputField
        lineHeight="normal" // safari fix
        value={watch}
        isInvalid={Boolean(fieldState.error)}
        onChange={field.onChange}
        onBlur={(e) => {
          const formattedValue = formatValue(e.target.value);
          field.onBlur();
          field.onChange(formattedValue);
        }}
        onKeyDown={(e) => e.stopPropagation()}
        px={2}
        border="none"
        bg="M.30"
        sx={{ w: 20 }}
        {...rest}
      />
    </ListItem>
  );
};
